import StimulusTomSelect from "stimulus-tom-select";
import { get } from "@rails/request.js";

// Connects to data-controller="remote-tom-select"
export default class extends StimulusTomSelect {
  static values = {
    value: String,
    label: String,
    path: String,
    multiple: { type: Boolean, default: true }
  };

  initTomSelect() {
    this.options = {
      valueField: this.valueValue,
      labelField: this.labelValue,
      searchField: this.labelValue,
      maxItems: 1,
      load: (query, callback) => {
        if (!query.length) return callback();
        get(this.pathValue, {
          responseKind: 'json',
          query: { q: query }
         })
         .then(response => {
          response.json.then(data => {
            callback(data)
            return
          })
         })
         .catch(() => callback())
      },
      ...this.optionsValue,
    };

    super.initTomSelect();
  }
}
